import { render, staticRenderFns } from "./payments_per_year.vue?vue&type=template&id=884436b0&scoped=true&"
import script from "./payments_per_year.vue?vue&type=script&lang=js&"
export * from "./payments_per_year.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "884436b0",
  null
  
)

export default component.exports